





































































































































































/* eslint-disable */
import Vue from 'vue'
import SeismicForm, {DeresmaForm, DeresmaGaineForm, InspectionConclusion, RobustesseForm} from '@/models/SeismicForm'
import SynchronizeStatus from "@/components/SynchronizeStatus.vue";
import PrintableForm from "@/views/PrintableForm.vue";
import XLSX, { WorkSheet, WritingOptions } from 'xlsx-js-style'

import {mapActions, mapGetters, mapMutations} from 'vuex'
import QRCode from 'qrcode'
import sha1 from 'node-sha1'

export default Vue.extend({

  components: {
    PrintableForm,
    SynchronizeStatus
  },

  props: {
    seismicForms: { type: Array, default: () => [] },
    selectedInspectors: {type: Array, default: () => []}
  },


  data: () => {
    return {
      activeCampaign: {} as Campaign,
      numberFilter: "" as string,
      batFilter: "" as string,
      localFilter: "" as string,
      commentFilter: "" as string,
      statusFilter: "" as string,
      dateFilter: "" as string,
      visibleCampaignRemovalConfirmation: false as boolean,
      selectedCampaignForRemoval: null as null | Campaign,
      confirmationSlug: '',
      displaySyncPanel: false,
      filteredForms: [] as Array<SeismicForm>,
      teamName: ''
    }
  },

  computed: {
    ...mapGetters(['getPinnedForms', "getSelectedCampaign", 'getSelectedCampaignSeismicForms', 'getNumberFilter', 'getBatFilter', 'getLocalFilter', 'getCommentFilter', 'getStatusFilter']),
    campaigns (): Array<Campaign> {
      const campaigns: Array<Campaign> = [];

      (this.seismicForms as Array<SeismicForm>).forEach((item: SeismicForm) => {
        const rightCampaign = campaigns.filter(campaign => campaign.title === item.campaign)
        if (rightCampaign.length === 0) {
          rightCampaign.push({ title: item.campaign, type: item.type, forms: [], visible: false })
          campaigns.push(rightCampaign[0])
        }

        const exists = rightCampaign[0].forms.filter((form: SeismicForm) => form.numeroFiche === item.numeroFiche && form.campaign === item.campaign).length > 0
        if (!exists) {
          rightCampaign[0].forms.push(item)
        }
        return rightCampaign
      })
      return campaigns
    }
  },

  watch: {
    numberFilter () {
      this.filterForms()
      this.setNumberFilter(this.numberFilter)
    },
    batFilter () {
      this.filterForms()
      this.setBatFilter(this.batFilter)
    },
    localFilter () {
      this.filterForms()
      this.setLocalFilter(this.localFilter)
    },
    commentFilter () {
      this.filterForms()
      this.setCommentFilter(this.commentFilter)
    },
    statusFilter () {
      this.filterForms()
      this.setStatusFilter(this.statusFilter)
    },
    dateFilter () {
      this.filterForms()
      this.setDateFilter(this.dateFilter)
    },
    getSelectedCampaign () {
      this.filterForms()
    }
  },
  created() {
    this.numberFilter = this.getNumberFilter
    this.batFilter = this.getBatFilter
    this.localFilter = this.getLocalFilter
    this.commentFilter = this.getCommentFilter
    this.statusFilter = this.getStatusFilter
    this.filterForms()
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "UPDATE_SEISMIC_FORMS") {
        console.log("UPDATE_SEISMIC_FORMS")
        this.filterForms()
      }
    })
  },
  methods: {
    ...mapActions(['pinForm', 'unpinForm', 'selectCampaign', 'removeCampaign', 'setNumberFilter', 'setBatFilter', 'setLocalFilter', 'setCommentFilter', 'setStatusFilter', 'setDateFilter']),
    ...mapGetters(['getSeismicForms']),

    filterForms() {
      const numberR = new RegExp(this.numberFilter.toLowerCase().replace('*', '([A-z\-0-9\ ])*'))
      const batR = new RegExp(this.batFilter.toLowerCase().replace('*', '([A-z\-0-9 ])*'))
      const localR = new RegExp(this.localFilter.toLowerCase().replace('*', '([A-z\-0-9 ])*'))
      const commentR = new RegExp(this.commentFilter.toLowerCase().replace('*', '([A-z\-0-9 ])+'))
      const statusR = new RegExp(this.statusFilter.toLowerCase().replace('*', '([A-z\-0-9 ])*'))
      const date = this.dateFilter ? new Date(this.dateFilter) : null

      this.filteredForms = this.getSelectedCampaign?.forms?.filter((form: SeismicForm) => (
          (this.numberFilter.length < 1 || form.numeroFiche.toLowerCase().search(numberR) >= 0) &&
          (this.batFilter.length < 1 || form.bat.toLowerCase().search(batR) >= 0) &&
          (this.localFilter.length < 1 || form.tenants2!.toLowerCase()!.search(localR) >= 0 || form.aboutissants2!.toLowerCase()!.search(localR) >= 0) &&
          (this.commentFilter.length < 1 || form.comment.toLowerCase().search(commentR) >= 0) &&
          (this.statusFilter.length < 1 || form.status.toLowerCase().search(statusR) >= 0) &&
          (!date || (form.updateDate?.toISOString && form.updateDate?.toISOString().split('T')[0] === date.toISOString().split('T')[0]))
      ))
    },

    unpinAllForms() {
      const pinned = [...this.getPinnedForms]
      pinned.forEach((form: SeismicForm) => this.unpinForm(form))
    },

    selectForm (form: SeismicForm) {
      if (form.type === "Robustesse"){
         this.$router.push(`Rform/${form.campaign}/${form.numeroFiche}`)
      }
      else if (form.type === "Deresma ind.E"){
         this.$router.push(`Dform/${form.campaign}/${form.numeroFiche}`)
      }
      else if (form.type === "Deresma Gaine"){
         this.$router.push(`DGform/${form.campaign}/${form.numeroFiche}`)
      }
    },

    isFormPinned(form: SeismicForm): boolean {
      return this.getPinnedForms.filter((pinnedForm: SeismicForm) =>
        pinnedForm.campaign === form.campaign &&
        pinnedForm.numeroFiche === form.numeroFiche).length > 0
    },

    displayCampaignRemovalConfirmation(campaign: Campaign) {
      console.log('Demande suppression de la campagne', {...campaign})
      this.selectedCampaignForRemoval = campaign
      this.visibleCampaignRemovalConfirmation = true
      this.confirmationSlug = ''
      // this.removeCampaign(campaign)
    },

    cancelCampaignRemoval() {
      this.visibleCampaignRemovalConfirmation = false
      this.selectedCampaignForRemoval = null
      this.confirmationSlug = ''
    },

    confirmCampaignRemoval(campaign: Campaign) {
      this.removeCampaign(campaign)
      // Cancel after removal to come back to clean UI:
      this.cancelCampaignRemoval()
    },

    exportJSON (campaignName: string) {
      const formsToExport = JSON.stringify((this.getSeismicForms().filter((form: SeismicForm) => form.campaign === campaignName)), null, 2)
      const file = new Blob(
        [`{ "version": 1, "application": "ofis", "campaign": ${formsToExport} }`],
        { type: 'application/json' }
      )

      const fileURL = URL.createObjectURL(file)
      const linkElement = document.createElement('a')
      linkElement.setAttribute('href', fileURL)
      linkElement.setAttribute('download', `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${campaignName.replace(' ', '-')}.odata`)
      document.body.appendChild(linkElement)
      linkElement.click()
      // eslint-disable-next-line no-unused-expressions
      linkElement.parentNode?.removeChild(linkElement)
    },

    buildStatusQRCode() {
      const campaign = {
        title: this.getSelectedCampaign.title,
        checksum: this.calculateCheckSums(this.getSelectedCampaign as never),
        finished: [] as Array<number>,
        pending: [] as Array<number>,
        blocked: [] as Array<number>,
        teamName: this.teamName
      }
      this.displaySyncPanel = true
      this.getSelectedCampaign.hash = this.calculateCheckSums(this.getSelectedCampaign as never)
      this.getSelectedCampaign.forms.forEach((form: SeismicForm, index: number) => {
        if (form.status === 'En cours') {
          campaign.pending.push(index)
        } else if (form.status === 'Bloqué') {
          campaign.blocked.push(index)
        } else if (form.status === 'Terminé') {
          campaign.finished.push(index)
        }
      })
      QRCode.toCanvas(document.querySelector('#qrcode-canvas'), JSON.stringify(campaign), function error(error:any) {
        console.error(error)
      })
      //document.querySelector('#video-container')!.innerHTML += '<br>' + campaign.pending.length + ' fiches en cours<br>'
      //document.querySelector('#video-container')!.innerHTML += campaign.blocked.length + ' fiches bloquées<br>'
      //document.querySelector('#video-container')!.innerHTML += campaign.finished.length + ' fiches terminées<br>'
      console.log('SYNCHRO', campaign, JSON.stringify(campaign).length)
    },

    /**
     * Generate and return a checksum of the given Campaign
     */
    // FIXME: Refactor this duplication in a dedicated file
    calculateCheckSums (campaign: never): string {
      const CAMPAIGN_CHECKSUM = sha1(Buffer.from((campaign as any).forms.map((item: SeismicForm) => item.numeroFiche).join('')))
      console.debug('calculateCheckSums', CAMPAIGN_CHECKSUM)
      return CAMPAIGN_CHECKSUM
    },

    calorifugeSynthesis(form: SeismicForm){
      let value
      if (form.ligne1.calorifuge){
        value = form.ligne1.calorifugeEpc
      }
      else {
        value = '-'
      }

      if (form.ligne2?.numero) {
        if (form.ligne2.calorifuge){
          value = value + '/' + form.ligne2.calorifugeEpc
        }
        else {
          value = value + '/' + '-'
        }
      }

      if (form.ligne3?.numero) {
        if (form.ligne3.calorifuge){
          value = value + '/' + form.ligne3.calorifugeEpc
        }
        else {
          value = value + '/' + '-'
        }
      }

      if (form.ligne4?.numero) {
        if (form.ligne4.calorifuge){
          value = value + '/' + form.ligne4.calorifugeEpc
        }
        else {
          value = value + '/' + '-'
        }
      }
      return value
    },

    exportSynthesisFile (campaignName: string) {
      const formsToExport = JSON.parse(JSON.stringify((this.getSeismicForms()
        .filter((form: SeismicForm) =>
          form.campaign === campaignName))))

      console.log('EXCEL EXPORT', formsToExport);
      // Create an empty XLSX file
      const wb = XLSX.utils.book_new()
      wb.Props = {
        Title: 'Tableau de synthèse' + campaignName,
        Subject: 'Tableau de synthèse' + campaignName,
        Author: 'SOM Calcul',
        CreatedDate: new Date()
      }

      //
      // TODO: refactor the monster below to become maintainable...
      //

      // Create an empty sheet before filling it
      wb.SheetNames.push('Feuil1')
      if (formsToExport.length > 0 && formsToExport[0].type === 'Robustesse'){
        const arr = new Array(formsToExport.length + 10)
        for (let i = 0; i < arr.length; i++) {
          arr[i] = []
        }
        arr[6][0] = 'N° fiche'
        arr[6][1] = 'Bâtiment'
        arr[6][2] = 'DN'
        arr[6][3] = 'N° de ligne'
        arr[6][4] = 'Matériel'
        arr[6][5] = 'Local'
        arr[6][6] = 'Etat d\'inspection'
        arr[6][7] = 'Commentaires'
        arr[6][8] = 'Conclusion fiche d\'inspection'
        arr[6][9] = 'Détails'
        arr[6][10] = 'Action de maintenance'
        arr[6][11] = 'Modifications'

        for (let i = 0; i < formsToExport.length; i++) {
          const form: RobustesseForm = formsToExport[i]
          console.log('EXCEL ROBUSTESSE EXPORT', i);
          // if (!form.analysis.conclusion.inspectionDone) {
          //   continue
          // }
          arr[i + 7][0] = form.numeroFiche
          arr[i + 7][1] = form.bat
          arr[i + 7][2] = [form.ligne1.dn, form.ligne2?.dn, form.ligne3?.dn].filter(item => item?.length).join(' / ')
          arr[i + 7][3] = [form.ligne1.numero, form.ligne2?.numero, form.ligne3?.numero].filter(item => item?.length).join(' / ')
          arr[i + 7][4] = [form.ligne1.robinet, form.ligne2?.robinet, form.ligne3?.robinet].filter(item => item?.length).join(' / ')
          arr[i + 7][5] = [form.ligne1.local, form.ligne2?.local, form.ligne3?.local].filter(item => item?.length).join(' / ')

          // "C" = "Conclusion" for the next lines
          let progress
          // const existsC3 = form.analysis.simpleTrunkAnalysis3.postSeismicREXisApplied
          // const existsC4 = form.analysis.simpleTrunkAnalysis4.postSeismicREXisApplied
          // const existsCSensible = form.analysis.sensibleTrunkAnalysis.dutyPaidMaterial
          // const existsGlobalC = form.analysis.simpleTrunkAnalysis4
          // existsC3 && existsC4 && existsCSensible && existsGlobalC? progress = 'Complète (100%)': ''
          // existsC3 || existsC4 || existsCSensible || existsGlobalC? progress = 'Partielle': ''
          if(form.analysis.conclusion.inspectionDone === true) {
            progress = 'Complète (100%)'
          }
          else if(form.analysis.conclusion.inspectionDone === 'partiel') {
            progress = 'Partielle'
          }
          else {
            progress = '0% (inaccessible)'
          }
          arr[i + 7][6] = progress
          arr[i + 7][7] = form.analysis.conclusion.comment
          arr[i + 7][8] = (InspectionConclusion[form.analysis.conclusion.inspectionConclusion as any] as any) || form.analysis.conclusion.inspectionConclusion as any
          arr[i + 7][9] = form.analysis.conclusion.comment + (form.analysis.conclusion.comment ===''? '': '\n') + form.analysis.specificPoints
            .filter(point => point.type === 'réserve')
            .map(point => `${ point.refPhoto ? 'Photo(s)': '' } ${point.refPhoto} - ${point.element} ${point.problem}`)
            .join('\n')
          arr[i + 7][10] = form.analysis.specificPoints
            .filter(point => point.type === 'am')
            .map(point => `${ point.refPhoto ? 'Photo(s)': '' } ${point.refPhoto} - ${point.element} ${point.problem}`)
            .join('\n')
          arr[i + 7][11] = form.analysis.specificPoints
            .filter(point => point.type === 'modif')
            .map(point => `${ point.refPhoto ? 'Photo(s)': '' } ${point.refPhoto} - ${point.element} ${point.problem}`)
            .join('\n')
        }
        wb.Sheets.Feuil1 = XLSX.utils.aoa_to_sheet(arr)

        wb.Sheets.Feuil1['!cols'] = [
          { wch: 20 },
          { wch: 9 },
          { wch: 9 },
          { wch: 9 },
          { wch: 16 },
          { wch: 6 },
          { wch: 11 },
          { wch: 36 },
          { wch: 36 },
          { wch: 36 },
          { wch: 36 },
          { wch: 36 }
        ]

        colorizeWSrobustesse(wb.Sheets.Feuil1, formsToExport)
      }
      else if (formsToExport.length > 0 && formsToExport[0].type === 'Deresma ind.E'){
        const arr = new Array(formsToExport.length + 10)
        for (let i = 0; i < arr.length; i++) {
          arr[i] = []
        }
        arr[6][0] = 'N° fiche'
        arr[6][1] = 'Bâtiment'
        arr[6][2] = 'DN'
        arr[6][3] = 'N° ligne'
        arr[6][4] = 'Matériel'
        arr[6][5] = 'Matériau'
        arr[6][6] = 'Calorifuge'
        arr[6][7] = 'Local'
        arr[6][8] = 'Tenant/Aboutissant'
        arr[6][9] = 'Pas admissible horizontal (m)'
        arr[6][10] = 'Pas admissible vertical (m)'
        arr[6][11] = 'Etat d\'inspection'
        arr[6][12] = 'Assimilation du complément d\'étude TTS ?'
        arr[6][13] = 'Commentaires'
        arr[6][14] = 'Conclusion fiche d\'inspection'
        arr[6][15] = 'Critère C ou D'
        arr[6][16] = 'Optimisations'
        arr[6][17] = 'PNS (Ks=1)'
        arr[6][18] = 'Détails'
        arr[6][19] = 'Action de maintenance'
        arr[6][20] = 'Modifications'

      for (let i = 0; i < formsToExport.length; i++) {
          const form: DeresmaForm = formsToExport[i]
          console.log('EXCEL DERESMA EXPORT', i);
          arr[i + 7][0] = form.numeroFiche
          arr[i + 7][1] = form.bat
          arr[i + 7][2] = [form.ligne1.dn, form.ligne2?.dn, form.ligne3?.dn, form.ligne4?.dn].filter(item => item?.length).join(' / ')
          arr[i + 7][3] = [form.ligne1.numero, form.ligne2?.numero, form.ligne3?.numero, form.ligne4?.numero].filter(item => item?.length).join(' / ')
          arr[i + 7][4] = [form.ligne1.reference, form.ligne2?.reference, form.ligne3?.reference, form.ligne4?.reference].filter(item => item?.length).join(' / ')
          arr[i + 7][5] = [form.ligne1.materiaux, form.ligne2?.materiaux, form.ligne3?.materiaux, form.ligne4?.materiaux].filter(item => item?.length).join(' // ')
          arr[i + 7][6] = this.calorifugeSynthesis(form)
          arr[i + 7][7] = form.tenants2 == form.aboutissants2 ? form.tenants2 : form.tenants2 + ' / ' + form.aboutissants2
          arr[i + 7][8] = form.tenants == form.aboutissants ? form.tenants : form.tenants + ' / ' + form.aboutissants
          arr[i + 7][9] = form.analysis.seismicCapacity.allowableHStepValue
          arr[i + 7][10] = form.analysis.seismicCapacity.allowableVStepValue
          let progress
          if(form.analysis.conclusion.inspectionDone === true) {
            progress = 'Complète (100%)'
          }
          else if(form.analysis.conclusion.inspectionDone === 'partiel') {
            progress = 'Partielle'
          }
          else {
            progress = '0% (inaccessible)'
          }
          arr[i + 7][11] = progress
          arr[i + 7][12] = ''
          arr[i + 7][13] = form.analysis.conclusion.comment
          arr[i + 7][14] = (InspectionConclusion[form.analysis.conclusion.inspectionConclusion as any] as any) || form.analysis.conclusion.inspectionConclusion as any
          arr[i + 7][15] = [form.ligne1.niveau, form.ligne2?.niveau, form.ligne3?.niveau, form.ligne4?.niveau].filter(item => item?.length).join(' / ')
          arr[i + 7][16] = ''
          arr[i + 7][17] = form.analysis.inspectionCriteria5.noTappingDefect === undefined ? 'non' : 'oui'
          const pointReserve = form.analysis.specificPoints.filter(p => p.type === 'réserve').map((point) => {return point.element + ' ' + point.problem})
          arr[i + 7][18] = pointReserve.length>0? pointReserve.join(' / ') : '-'
          const pointAm = form.analysis.specificPoints.filter(p => p.type === 'am').map((point) => {return point.element + ' ' + point.problem})
          arr[i + 7][19] = pointAm.length>0? pointAm.join(' / ') : '-'
          const pointModif = form.analysis.specificPoints.filter(p => p.type === 'modif').map((point) => {return point.element + ' ' + point.problem})
          arr[i + 7][20] = pointModif.length>0? pointModif.join(' / ') : '-'
        }
        wb.Sheets.Feuil1 = XLSX.utils.aoa_to_sheet(arr)

        colorizeWSderesma(wb.Sheets.Feuil1, formsToExport)
      }
      else if (formsToExport.length > 0 && formsToExport[0].type === 'Deresma Gaine'){
         const arr = new Array(formsToExport.length + 10)
        for (let i = 0; i < arr.length; i++) {
          arr[i] = []
        }
        arr[6][0] = 'N° fiche'
        arr[6][1] = 'Périmètre'
        arr[6][2] = 'Site/Tranche/SE/Local'
        arr[6][3] = 'Section'
        arr[6][4] = 'Epaisseur'
        arr[6][5] = 'N° Gaine'
        arr[6][6] = 'Matériel'
        arr[6][7] = 'Matériau'
        arr[6][8] = 'Protection incendie'
        arr[6][9] = 'Local'
        arr[6][10] = 'Tenant/Aboutissant'
        arr[6][11] = 'Pas mesuré horizontal (m)'
        arr[6][12] = 'Pas mesuré vertical (m)'
        arr[6][13] = 'Pas admissible horizontal (m)'
        arr[6][14] = 'Pas admissible vertical (m)'
        arr[6][15] = 'Etat d\'inspection'
        arr[6][16] = 'Assimilation du complément d\'étude TTS ?'
        arr[6][17] = 'Commentaires'
        arr[6][18] = 'Conclusion fiche d\'inspection'
        arr[6][19] = 'Optimisations'
        arr[6][20] = 'Détails'
        arr[6][21] = 'Action de maintenance'
        arr[6][22] = 'Modifications'

      for (let i = 0; i < formsToExport.length; i++) {
          const form: DeresmaGaineForm = formsToExport[i]
          arr[i + 7][0] = form.numeroFiche
          arr[i + 7][1] = ""
          arr[i + 7][2] = form.data.site_tranche_se_local
          arr[i + 7][3] = form.data.section_epaisseur?.map(item => item.section).join('\n')
          arr[i + 7][4] = form.data.section_epaisseur?.map(item => item.epaisseur).join('\n')
          arr[i + 7][5] = ""
          arr[i + 7][6] = ""
          arr[i + 7][7] = form.data.materiau
          arr[i + 7][8] = form.data.protection_incendie
          arr[i + 7][9] = form.data.local
          arr[i + 7][10] = ""
          arr[i + 7][11] = form.analysis.capacite_sismique_gaines.pas_horizontal_mesuré
          arr[i + 7][12] = form.analysis.capacite_sismique_gaines.pas_vertical_mesuré
          arr[i + 7][13] = form.analysis.capacite_sismique_gaines.pas_horizontal_admissible
          arr[i + 7][14] = form.analysis.capacite_sismique_gaines.pas_vertical_admissible
          let progress
          if(form.analysis.conclusion.inspectionDone === true) {
            progress = 'Complète (100%)'
          }
          else if(form.analysis.conclusion.inspectionDone === 'partiel') {
            progress = 'Partielle'
          }
          else {
            progress = '0% (inaccessible)'
          }
          arr[i + 7][15] = progress
          arr[i + 7][16] = ""
          arr[i + 7][17] = form.data.commentaire1
          arr[i + 7][18] = (InspectionConclusion[form.analysis.conclusion.inspectionConclusion as any] as any) || form.analysis.conclusion.inspectionConclusion as any
          arr[i + 7][19] = form.data.niveau_local
          const pointReserve = form.analysis.specificPoints.filter(p => p.type === 'réserve').map((point) => {return point.element + ' ' + point.problem})
          arr[i + 7][20] = pointReserve.length>0? pointReserve.join(' / ') : '-'
          const pointAm = form.analysis.specificPoints.filter(p => p.type === 'am').map((point) => {return point.element + ' ' + point.problem})
          arr[i + 7][21] = pointAm.length>0? pointAm.join(' / ') : '-'
          const pointModif = form.analysis.specificPoints.filter(p => p.type === 'modif').map((point) => {return point.element + ' ' + point.problem})
          arr[i + 7][22] = pointModif.length>0? pointModif.join(' / ') : '-'

        }
        wb.Sheets.Feuil1 = XLSX.utils.aoa_to_sheet(arr)
        colorizeWSderesma(wb.Sheets.Feuil1, formsToExport, "S")

      } else{
        console.error("Les formulaires ne sont ni Robustesse ni Deresma ind.E.")
      }

      // partie commune aux deux types de synthèse


      console.log('WSHEET', wb.Sheets.Feuil1);
      wb.Sheets.Feuil1.A7.s = headerCellStyle
      wb.Sheets.Feuil1.B7.s = headerCellStyle
      wb.Sheets.Feuil1.C7.s = headerCellStyle
      wb.Sheets.Feuil1.D7.s = headerCellStyle
      wb.Sheets.Feuil1.E7.s = headerCellStyle
      wb.Sheets.Feuil1.F7.s = headerCellStyle
      wb.Sheets.Feuil1.G7.s = headerCellStyle
      wb.Sheets.Feuil1.H7.s = headerCellStyle
      wb.Sheets.Feuil1.I7.s = headerCellStyle
      wb.Sheets.Feuil1.J7.s = headerCellStyle
      wb.Sheets.Feuil1.K7.s = headerCellStyle
      wb.Sheets.Feuil1.L7.s = headerCellStyle
      if (formsToExport.length > 0 && formsToExport[0].type === 'Deresma ind.E'){
        wb.Sheets.Feuil1.M7.s = headerCellStyle
        wb.Sheets.Feuil1.N7.s = headerCellStyle
        wb.Sheets.Feuil1.O7.s = headerCellStyle
        wb.Sheets.Feuil1.P7.s = headerCellStyle
        wb.Sheets.Feuil1.Q7.s = headerCellStyle
        wb.Sheets.Feuil1.R7.s = headerCellStyle
        wb.Sheets.Feuil1.S7.s = headerCellStyle
        wb.Sheets.Feuil1.T7.s = headerCellStyle
        wb.Sheets.Feuil1.U7.s = headerCellStyle
      }
      if (formsToExport.length > 0 && formsToExport[0].type === 'Deresma Gaine'){
        wb.Sheets.Feuil1.M7.s = headerCellStyle
        wb.Sheets.Feuil1.N7.s = headerCellStyle
        wb.Sheets.Feuil1.O7.s = headerCellStyle
        wb.Sheets.Feuil1.P7.s = headerCellStyle
        wb.Sheets.Feuil1.Q7.s = headerCellStyle
        wb.Sheets.Feuil1.R7.s = headerCellStyle
        wb.Sheets.Feuil1.S7.s = headerCellStyle
        wb.Sheets.Feuil1.T7.s = headerCellStyle
        wb.Sheets.Feuil1.U7.s = headerCellStyle
        wb.Sheets.Feuil1.V7.s = headerCellStyle
        wb.Sheets.Feuil1.W7.s = headerCellStyle
      }

      const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' }
      const wbout = XLSX.write(wb, wopts as WritingOptions)
      const file = new Blob(
        [wbout],
        { type: 'application/octet-stream' }
      )

      const fileURL = URL.createObjectURL(file)
      const linkElement = document.createElement('a')
      linkElement.setAttribute('href', fileURL)
      linkElement.setAttribute('download', `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${campaignName.replace(' ', '-')}.xlsx`)
      document.body.appendChild(linkElement)
      linkElement.click()
      // eslint-disable-next-line no-unused-expressions
      linkElement.parentNode?.removeChild(linkElement)
    },
  }

})

/**
 * Take an Excel WS in params and apply style to each cell
 * depending on the study conclusion
 *
 * @param ws: XLSX worksheet containing row data of forms
 * @param forms: list of forms TS Objects (matching the row data in the ws param, but more complete)
 */
function colorizeWSrobustesse (ws: WorkSheet, forms: Array<SeismicForm>) {
  let rowStyle
  for (let i = 0; i < forms.length; i++) {
    if(ws && ws[`A${i + 7}`] && ws[`A${i + 8}`].v) {
      rowStyle = null
      switch (ws[`I${i + 7}`].v || ws[`O${i + 8}`].v) {
        case 'Dédouanée suite à l\'inspection sans réserve':
          rowStyle = goodCellStyle
          break
        case 'Complément d\'étude nécessaire':
          rowStyle = almostGoodCellStyle
          break
        case 'Dédouanée suite à l\'inspection sous réserve d\'une AM':
          rowStyle = suspicionCellStyle
          break
        case 'Non dédouanée suite à l\'impossibilité de mener l\'inspection':
          rowStyle = impossibleCellStyle
          break
        case 'Non dédouanée suite à l\'inspection, requiert une modification':
          rowStyle = suspicionCellStyle
          break

      }
      ws[`A${i + 8}`].s = rowStyle
      ws[`B${i + 8}`].s = rowStyle
      ws[`C${i + 8}`].s = rowStyle
      ws[`D${i + 8}`].s = rowStyle
      ws[`E${i + 8}`].s = rowStyle
      ws[`F${i + 8}`].s = rowStyle
      ws[`G${i + 8}`].s = rowStyle
      ws[`H${i + 8}`].s = rowStyle
      ws[`I${i + 8}`].s = rowStyle
      ws[`J${i + 8}`].s = rowStyle
      ws[`K${i + 8}`].s = rowStyle
      ws[`L${i + 8}`].s = rowStyle
    }
  }
}
function colorizeWSderesma(ws: WorkSheet, forms: Array<SeismicForm>, col_conclusion?: string) {
  let columns = [
    "A","B","C","D","E","F","G","H","I","J",
    "K","L","M","N","O","P","Q","R","S","T","U"
  ];
  if (forms[0].type === "Deresma Gaine") {
    columns.push("V")
    columns.push("W")
  }


  for (let i = 0; i < forms.length; i++) {
    const row = i + 8;
    const colKey = col_conclusion || "O";
    const cellKey = `${colKey}${row}`;

    // On vérifie que la ligne correspond à un enregistrement valide
    if (!ws[`A${row}`] || !ws[`A${row}`].v) continue;

    const value = ws[cellKey]?.v;
    let rowStyle: any = null;

    switch (value) {
      case "Dédouanée suite à l'inspection sans réserve":
        rowStyle = goodCellStyle;
        break;
      case "Complément d'étude nécessaire":
        rowStyle = almostGoodCellStyle;
        break;
      case "Dédouanée suite à l'inspection sous réserve d'une AM":
        rowStyle = suspicionCellStyle;
        break;
      case "Non dédouanée suite à l'impossibilité de mener l'inspection":
        rowStyle = impossibleCellStyle;
        break;
      case "Non dédouanée suite à l'inspection, requiert une modification":
        rowStyle = suspicionCellStyle;
        break;
    }

    // Appliquer le style à chaque colonne de la ligne
    for (const col of columns) {
      const addr = `${col}${row}`;
      if (!ws[addr]) {
        ws[addr] = { t: "s", v: "" }; // ✅ initialise la cellule vide
      }
      ws[addr].s = rowStyle;
    }
  }
}



const goodCellStyle = {
  fill: {
    patternType: 'solid',
    fgColor: { rgb: 'FFe2efda' }
  },
  font: {
    sz: 10,
  },
  alignment: {
    vertical: 'center',
    horizontal: 'center',
    wrapText: '1' // any truthy value here
  },
  border: {
    top: {
      color: { rgb: '333333'},
      style:'thin'
    },
    left: {
      color: { rgb: '333333'},
      style:'thin'
    },
    bottom: {
      color: { rgb: '333333'},
      style:'thin'
    },
    right: {
      color: { rgb: '333333'},
      style:'thin'
    },

  }
}
const headerCellStyle = {
  fill: {
    patternType: 'solid',
    fgColor: { rgb: 'FF9FFD95' }
  },
  font: {
    sz: 12,
    bold: true,
  },
  alignment: {
    vertical: 'center',
    horizontal: 'center',
    wrapText: '1' // any truthy value here
  },
  border: {
    top: {
      color: { rgb: '333333'},
      style:'thin'
    },
    left: {
      color: { rgb: '333333'},
      style:'thin'
    },
    bottom: {
      color: { rgb: '333333'},
      style:'thin'
    },
    right: {
      color: { rgb: '333333'},
      style:'thin'
    },

  }
}
const almostGoodCellStyle = {
  fill: {
    patternType: 'solid',
    fgColor: { rgb: 'FFffff9a' }
  },
  font: {
    sz: 10,
  },
  alignment: {
    vertical: 'center',
    horizontal: 'center',
    wrapText: '1' // any truthy value here
  },
  border: {
    top: {
      color: { rgb: '333333'},
      style:'thin'
    },
    left: {
      color: { rgb: '333333'},
      style:'thin'
    },
    bottom: {
      color: { rgb: '333333'},
      style:'thin'
    },
    right: {
      color: { rgb: '333333'},
      style:'thin'
    },

  }
}
const suspicionCellStyle = {
  fill: {
    patternType: 'solid',
    fgColor: { rgb: 'FFf4b185' }
  },
  font: {
    sz: 10,
  },
  alignment: {
    vertical: 'center',
    horizontal: 'center',
    wrapText: '1' // any truthy value here
  },
  border: {
    top: {
      color: { rgb: '333333'},
      style:'thin'
    },
    left: {
      color: { rgb: '333333'},
      style:'thin'
    },
    bottom: {
      color: { rgb: '333333'},
      style:'thin'
    },
    right: {
      color: { rgb: '333333'},
      style:'thin'
    },

  }
}
const impossibleCellStyle = {
  fill: {
    patternType: 'solid',
    fgColor: { rgb: 'FFff8a8d' }
  },
  font: {
    sz: 10,
  },
  alignment: {
    vertical: 'center',
    horizontal: 'center',
    wrapText: '1' // any truthy value here
  },
  border: {
    top: {
      color: { rgb: '333333'},
      style:'thin'
    },
    left: {
      color: { rgb: '333333'},
      style:'thin'
    },
    bottom: {
      color: { rgb: '333333'},
      style:'thin'
    },
    right: {
      color: { rgb: '333333'},
      style:'thin'
    },

  }
}

interface Campaign {
  title: string
  type: string
  visible: boolean
  forms: Array<SeismicForm>
}
